import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

export default function SimplePagination({ page, setPage, hasNextPage }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Tooltip title="Previous page">
        <span>
          <IconButton
            size="small"
            disabled={page === 0}
            onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          >
            <KeyboardArrowLeft />
          </IconButton>
        </span>
      </Tooltip>

      <Typography variant="body2" color="text.secondary">
        Page <strong>{page + 1}</strong>
      </Typography>

      <Tooltip title="Next page">
        <span>
          <IconButton
            size="small"
            disabled={!hasNextPage}
            onClick={() => setPage((prev) => prev + 1)}
          >
            <KeyboardArrowRight />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}

SimplePagination.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool.isRequired
};
